import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/store/auth'
import { useErrorsStore } from '@/store/errors'
import {
  SUPPORT_GROUP,
  CONVERSATIONS_STATS_PERMISSION,
  CRISP_MONITORING_PERMISSION,
  CAN_ACCESS_EXTERNAL_REVIEW_CODENAME,
  AI_PIPELINE_TEST_PERMISSION,
} from '@/utils/permissions'
import NotAuthorizedPage from '@/views/NotAuthorizedPage.vue'
import NotFoundPage from '@/views/NotFoundPage.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/HomePage.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginPage.vue'),
    },
    {
      path: '/chat',
      name: 'chat',
      component: () => import('@/views/ChatPage.vue'),
      meta: { permission: SUPPORT_GROUP },
    },
    {
      path: '/crisp-monitor',
      name: 'crisp-monitor',
      component: () => import('@/views/ChatMonitorPage.vue'),
      meta: { permission: CRISP_MONITORING_PERMISSION },
    },
    {
      path: '/conversation-monitor',
      name: 'conversation-monitor',
      component: () => import('@/views/ConversationMonitorPage.vue'),
      meta: { permission: CRISP_MONITORING_PERMISSION },
    },
    {
      path: '/conversations-stats/aggregate',
      name: 'conversations-stats-aggregate',
      component: () => import('@/views/ConversationStatPage.vue'),
      meta: { permission: CONVERSATIONS_STATS_PERMISSION },
    },
    {
      path: '/conversations-stats/load',
      name: 'conversations-stats-load',
      component: () => import('@/views/ConversationStatPage.vue'),
      meta: { permission: CONVERSATIONS_STATS_PERMISSION },
    },
    {
      path: '/conversations-stats',
      name: 'conversations-stats',
      component: () => import('@/views/ConversationStatPage.vue'),
      meta: { permission: CONVERSATIONS_STATS_PERMISSION },
    },
    {
      path: '/emails',
      name: 'emails',
      component: () => import('@/views/EmailsPage.vue'),
      meta: { permission: SUPPORT_GROUP },
    },
    {
      path: '/reviews',
      name: 'reviews',
      component: () => import('@/views/ReviewPage.vue'),
      meta: { permission: CAN_ACCESS_EXTERNAL_REVIEW_CODENAME },
    },
    {
      path: '/logs-ia',
      name: 'logs-ia',
      component: () => import('@/views/LogsIaPage.vue'),
      meta: { permission: SUPPORT_GROUP },
    },
    {
      path: '/logs-ia/sans-suggestion',
      name: 'logs-ia-no-suggestion',
      component: () => import('@/views/LogsIaNoSuggestionPage.vue'),
      meta: { permission: SUPPORT_GROUP },
    },
    {
      path: '/self-service-claims',
      name: 'self-service-claims',
      component: () => import('@/views/SelfServiceClaimsPage.vue'),
      meta: { permission: SUPPORT_GROUP },
    },
    {
      path: '/test-pipeline-ia',
      name: 'ai-pipeline-test',
      component: () => import('@/views/AiPipelineTestPage.vue'),
      meta: { permission: AI_PIPELINE_TEST_PERMISSION },
    },
    {
      path: '/not-authorized',
      name: '401',
      component: NotAuthorizedPage,
    },
    {
      path: '/:pathMatch(.*)*',
      name: '404',
      component: NotFoundPage,
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  await authStore.checkToken()

  if (to.name !== 'login' && !authStore.isAuthenticated) {
    if (!authStore.isAuthenticated) {
      next({ name: 'login' })
      return
    }
  } else if (to.name === 'login' && authStore.isAuthenticated) {
    next({ name: 'home' })
    return
  } else if (to.meta.permission) {
    if (!authStore.hasPermission(to.meta.permission)) {
      next({ name: '401' })
      return
    }
  }
  next()
})

router.onError((error, to) => {
  if (error.message.includes('Failed to fetch dynamically imported module')) {
    // Interception des erreurs liées à une mise à jour de code
    const errorsStore = useErrorsStore()
    errorsStore.encouterDeprecatedCodeError()
  }
})
export default router
